export const calculateNewDataInFactor = (table, cell, field, value) => {

  const productIdKey = 'na_32'
  const storeIdKey = 'na_707'

  const productId = cell.getData()[productIdKey];
  const storeId = cell.getData()[storeIdKey];

  table.forEach(v => {
    if (v[productIdKey] === productId && v[storeIdKey] === storeId) {
      v[field] = value
    }

  })

  return table

}

export const calculateSumOfEachRowInOldFactor = (table ) => {
  const temp = [...table]

  temp.forEach(row => {
    // total = price - discount * number
    row.total = (row['na_89'] - row['na_264']) * row['na_319']
  })

  return temp

}

